import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EscalatorWarningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"escalator_warning"}/>
}
